import { DestroyRef } from '@angular/core';
import { Subscription } from 'rxjs';

class SubscriptionHelper {
  private _subscriptions: Subscription[] = [];

  constructor(destroyRef: DestroyRef) {
    destroyRef.onDestroy(() => {
      this.unsubscribe();
    });
  }

  add(subscription: Subscription): void {
    this._subscriptions.push(subscription);
  }

  unsubscribe(): void {
    this._subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
}

export { SubscriptionHelper };